<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="control" [multiple]="true" panelClass="select-hierarchical-wrapper">
    <span *ngFor="let group of groups" class="select-hierarchical">
      <!-- The group checkbox -->
      <mat-checkbox
        *ngIf="group.label"
        class="mat-option"
        [indeterminate]="groupStates[group.label] === GroupStateEnum.PARTIALLY_SELECTED"
        [checked]="!!groupStates[group.label]"
        (change)="toggleGroup($event, group)"
        >{{ group.label }}</mat-checkbox
      >
      <!-- The sub items checkboxes -->
      <mat-option
        (click)="computeGroupState(item, group)"
        class="sub-item"
        *ngFor="let item of group.subitems"
        [value]="item.id"
        >{{ item.label }}</mat-option
      >
    </span>
  </mat-select>
</mat-form-field>
